var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.218 18.255 18.255 4.218c.34-.34.959-.275 1.38.146.422.422.488 1.04.147 1.38L5.745 19.783c-.34.34-.959.275-1.38-.146-.422-.422-.488-1.04-.147-1.38z",
    fill: "#F2E6C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5.745 4.218 14.037 14.037c.34.34.275.959-.146 1.38-.422.422-1.04.488-1.38.147L4.217 5.745c-.34-.34-.275-.959.146-1.38.422-.422 1.04-.488 1.38-.147z",
    fill: "#F2E6C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.f709ea6e8d0db18bd117ff590773188a.svg";
export { ForwardRef as ReactComponent };